import { render, staticRenderFns } from "./DashboardOnly.vue?vue&type=template&id=4c916c24&scoped=true&"
import script from "./DashboardOnly.vue?vue&type=script&lang=js&"
export * from "./DashboardOnly.vue?vue&type=script&lang=js&"
import style0 from "./DashboardOnly.vue?vue&type=style&index=0&id=4c916c24&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c916c24",
  null
  
)

export default component.exports